import { createRoute } from '@tanstack/react-router'
import { rootRoute } from 'src/router/root-route'

import GuestLayout from '../GuestLayout'

export const guestLayoutRoute = createRoute({
  getParentRoute: () => rootRoute,
  component: () => <GuestLayout />,
  id: 'guest-layout'
})
